import { gql } from "@apollo/client";

/** Nucleus assistant (core-hosted, ROOT only). The gateway returns core's
 * response envelope as a JSON string — parse with parseAssistantEnvelope. */

export const ASSISTANT_CHAT = gql`
  mutation AssistantChat(
    $message: String!
    $conversationId: String
    $uiContext: String
    $attachments: [AssistantAttachmentInput!]
    $model: String
    $effort: String
  ) {
    assistantChat(
      message: $message
      conversationId: $conversationId
      uiContext: $uiContext
      attachments: $attachments
      model: $model
      effort: $effort
    )
  }
`;

/** Async turn: open it, then poll. A multi-part turn (proposals + engine run
 *  + report routing) runs longer than API Gateway's 30s wall allows a single
 *  request to, so the dock opens the turn and polls until it closes. */
export const ASSISTANT_CHAT_START = gql`
  mutation AssistantChatStart(
    $message: String!
    $conversationId: String
    $uiContext: String
    $attachments: [AssistantAttachmentInput!]
    $model: String
    $effort: String
  ) {
    assistantChatStart(
      message: $message
      conversationId: $conversationId
      uiContext: $uiContext
      attachments: $attachments
      model: $model
      effort: $effort
    )
  }
`;


export const ASSISTANT_CHAT_POLL = gql`
  query AssistantChatPoll($requestId: Int!) {
    assistantChatPoll(requestId: $requestId)
  }
`;

export const ASSISTANT_RESOLVE_CHANGE = gql`
  mutation AssistantResolveChange($changeId: String!, $action: String!) {
    assistantResolveChange(changeId: $changeId, action: $action)
  }
`;

/** The shared dock's generic passthrough to a core Nucleus route (past
 *  chats): `op` from the gateway's allow-list, `payload` a JSON object. */
export const ASSISTANT_CALL = gql`
  mutation AssistantCall($op: String!, $payload: String) {
    assistantCall(op: $op, payload: $payload)
  }
`;

/** Starter prompts: a random, page-ranked pick from the tools the caller can
 *  use (core's Tool.sample_queries / key_pages). uiContext = {page} — the
 *  same shape the chat turn sends. Never cache: each open is a fresh draw. */
export const ASSISTANT_SUGGESTIONS = gql`
  query AssistantSuggestions($uiContext: String) {
    assistantSuggestions(uiContext: $uiContext)
  }
`;

// The envelope types live in @atomic/ui-kit (`AssistantEnvelope`, the block
// union, `AssistantTurnPoll`, …): the shared dock parses the strings these
// operations return, and this app reads nothing from them itself.
